module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/NB.831fa759.png";